import {TezosToolkit, MichelsonMap} from '@taquito/taquito';
import {BeaconWallet} from '@taquito/beacon-wallet';
import * as config from '../config/config';
import {bytes2Char, char2Bytes} from '@taquito/utils';
import axios from 'axios';
// import { Exists } from 'faunadb';

// import { validateAddress } from '@taquito/utils';

// //valid
// const pkh = 'tz1L9r8mWmRPndRhuvMCWESLGSVeFzQ9NAWx';
// const validation = validateAddress(pkh);

// LIVE

const TezosLive = new TezosToolkit(config.LIVE_RPC_URL);
const optionsLive = {
    name: config.NAME,
    iconUrl: 'https://tezostaquito.io/img/favicon.png',
    preferredNetwork: config.LIVE_NETWORK,
};
const walletLive = new BeaconWallet(optionsLive);
TezosLive.setWalletProvider(walletLive);
const connectLiveWallet = async () => {
    await walletLive.requestPermissions({
        network: {
            type: config.LIVE_NETWORK,
        },
    });
    return walletLive;
};

const disconnectLiveWallet = async () => {
    await walletLive.clearActiveAccount();
};

const connectWalletLiveButton = async () => {
    const activeAccount = await walletLive.client.getActiveAccount();
    if (activeAccount) {
        console.log('already connected');
    } else {
        await disconnectLiveWallet();
        await connectLiveWallet();
    }
    window.location.reload();
}

const disconnectWalletLiveButton = async () => {
    const activeAccount = await walletLive.client.getActiveAccount();
    if (activeAccount) {
        await disconnectLiveWallet();
    } else {
        console.log('already disconnected');
    }
    window.location.reload();
}

const getIsWalletActiveLive = async () => {
    const activeAccount = await walletLive.client.getActiveAccount();
    if (activeAccount) {
        return true;
    } else {
        return false;
    }
}


// DEV

const Tezos = new TezosToolkit(config.RPC_URL);
const options = {
    name: config.NAME,
    iconUrl: 'https://tezostaquito.io/img/favicon.png',
    preferredNetwork: config.NETWORK,
};
const wallet = new BeaconWallet(options);
Tezos.setWalletProvider(wallet);
const connectWallet = async () => {
    await wallet.requestPermissions({
        network: {
            type: config.NETWORK,
        },
    });
    return wallet;
};
const disconnectWallet = async () => {
    await wallet.clearActiveAccount();
};

const connectWalletButton = async () => {
    const activeAccount = await wallet.client.getActiveAccount();
    if (activeAccount) {
        console.log('already connected');
    } else {
        await disconnectWallet();
        await connectWallet();
    }
    window.location.reload();
}

const disconnectWalletButton = async () => {
    const activeAccount = await wallet.client.getActiveAccount();
    if (activeAccount) {
        await disconnectWallet();
    } else {
        console.log('already disconnected');
    }
    window.location.reload();
}

const getIsWalletActive = async () => {
    const activeAccount = await wallet.client.getActiveAccount();
    console.log('activeAccount',activeAccount);
    if (activeAccount) {
        return true;
    } else {
        return false;
    }
}
//


const getPKH = async () => {
    const pkh = await wallet.getPKH();
    return pkh;
};

const getContract = async () => {
    const contract = await Tezos.wallet.at(config.CONTRACT_ADDRESS);
    return contract;
};

const getPlayerNftContract = async () => {
    const contract = await Tezos.wallet.at(config.PLAYER_CONTRACT_ADDRESS);
    return contract;
};

const getMarketNftContract = async () => {
    const contract = await Tezos.wallet.at(config.MARKET_CONTRACT_ADDRESS);
    return contract;
};

const getLiveMarketNftContract = async () => {
    const contract = await TezosLive.wallet.at(config.LIVE_MARKET_CONTRACT_ADDRESS);
    return contract;
};

const getLiveMarket2NftContract = async () => {
    const contract = await TezosLive.wallet.at(config.LIVE_MARKET_CONTRACT_ADDRESS2);
    return contract;
};
// NOT USED
const mintNFT = async (address, url, token_id) => {
    await disconnectWallet();
    await connectWallet();
    const amount = 1;
    const contract = await getContract();
    url = char2Bytes(url);
    const op = await contract.methods.mint(address, amount, MichelsonMap.fromLiteral({'': url}), token_id).send();
    return await op.confirmation(3);
};

const checkAccess = async () => {
  
    const userNfts = await getUserNFTs();
    //console.log('u',userNfts);
    if (userNfts.length > 0 ) {
        return true;
    } else {
        return false;
    }
    // async (walletAddress) => {
    // const response = await axios.get(
    //     `https://api.hangzhou2net.tzkt.io/v1/contracts/${config.CONTRACT_ADDRESS}/bigmaps/token_metadata/keys`
    // );
    // const data = response.data;
    // // let tokens = [];
    // for (let i = 0; i < data.length; i++) {
    //     console.log('token ',data[i].value);
    //     if (walletAddress === '') {
    //         return true;
    //     }
    // }
    // return true;
}

const getUserPlayerNfts = async () => {
    const activeAccount = await wallet.client.getActiveAccount();
    if (activeAccount) {
        console.log('already connected');
    } else {
        await disconnectWallet();
        await connectWallet();
    }
    let userNfts = [];
    //const amount = 1;
    const contract = await getPlayerNftContract();
    const nftStorage = await contract.storage();
    // console.log(nftStorage);
    const userWalletAddress = await getPKH();
    let getTokensIds = [];
    // let x = 0;
    // if (nftStorage.ledger) {
    //     nftStorage.ledger.valueMap.forEach(function(element, key){
    //         if (userWalletAddress === key.address) {
    //             getTokensIds.push(key.nat); 
    //             console.log('element',element);
    //         }
    //         x++;
    //     });
    // }
    const response = await axios.get(
        `https://api.hangzhou2net.tzkt.io/v1/contracts/${config.PLAYER_CONTRACT_ADDRESS}/bigmaps/ledger/keys`
    );
    const data = response.data;
    for (let i = 0; i < data.length; i++) {
        //console.log(data[i].key.address);
        if (userWalletAddress === data[i].key.address) {
            getTokensIds.push(data[i].key.nat); 
        }
    }

    //console.log('getTokensIds',getTokensIds);
    
    // const getTokensIds = await nftStorage.reverse_ledger.get(userWalletAddress);
    if (getTokensIds) {
        userNfts = await Promise.all(
            getTokensIds.map(async id => {
                const tokenId = 0 + id;
                const metadata = await nftStorage.token_metadata.get(tokenId)
                const tokenInfoBytes = metadata.token_info.get('');
                const tokenInfo = bytes2Char(tokenInfoBytes);
                return {
                    token_id: tokenId,
                    url: tokenInfo.slice(0,7) === "ipfs://" ? tokenInfo.slice(7) : null
                }
            })
        )
        
    }
    return userNfts;
};

const getUserMarketNftsLive = async () => {
    const activeAccount = await walletLive.client.getActiveAccount();
    if (activeAccount) {
        console.log('already connected');
    } else {
        await disconnectLiveWallet();
        await connectLiveWallet();
    }
    let userNfts = [];
    //const amount = 1;
    const contract = await getLiveMarketNftContract();
    const nftStorage = await contract.storage();
    // console.log(nftStorage);
    const userWalletAddress = await getPKH();
    const response = await axios.get(
        `https://api.mainnet.tzkt.io/v1/contracts/${config.LIVE_MARKET_CONTRACT_ADDRESS}/bigmaps/ledger/keys`
    );
    const data = response.data;
    let getTokensIds = [];
    for (let i = 0; i < data.length; i++) {
        //console.log(data[i].key.address);
        if (userWalletAddress === data[i].key.address) {
            getTokensIds.push(data[i].key.nat); 
        }
    }

    //console.log('getTokensIds',getTokensIds);
    
    // const getTokensIds = await nftStorage.reverse_ledger.get(userWalletAddress);
    if (getTokensIds) {
        userNfts = await Promise.all(
            getTokensIds.map(async id => {
                const tokenId = 0 + id;
                const metadata = await nftStorage.token_metadata.get(tokenId)
                const tokenInfoBytes = metadata.token_info.get('');
                const tokenInfo = bytes2Char(tokenInfoBytes);
                return {
                    token_id: tokenId,
                    url: tokenInfo.slice(0,7) === "ipfs://" ? tokenInfo.slice(7) : null
                }
            })
        )
        
    }
    return userNfts;
};

const getNftMetadata = async (url) => {
    try  {
        const response = await axios.get('https://ipfs.io/ipfs/' + url); //url.slice(7));
        let data = response.data;
        console.log("data", data);
        // token.name = data.name;
        // token.description = data.description;
        //if (data.displayUri) token.img = 'https://ipfs.io/ipfs/' + data.displayUri.slice(7);
        return {
            name: data.name,
            description: data.description,
            glbPath: 'https://ipfs.io/ipfs/' + data.artifactUri.slice(7),
            url: 'https://ipfs.io/ipfs/' + data.thumbnailUri.slice(7)
        }
    } catch (err) {
        console.log('getNftMetadata - error: ',err);
        return {
            name: 'Sorry there was an error getting NFT',
            description: '',
            glbPath: '/test.glb',
            url: '/test.jpg'
        }
    }
}

const getMarketNftsLiveById = async (id) => {
    let nftData = {
        name: 'Sorry no NFT found',
        description:'',
        glbPath:'/test.glb',
        url:'/tim.jpg'
    };
    const nfts = await getMarketNftsLive();
    console.log('nfts',nfts);
    for (let i = 0; i < nfts.length; i++) {
        console.log('id ',id);
        console.log('id ',nfts[i].token_id);
        if (parseInt(id) === parseInt(nfts[i].token_id)) {
            const url =  nfts[i].url;
            console.log('nfts',url);
            nftData = await getNftMetadata(url);
            break;
        }
    }
    return nftData;
}

const getMarketNftsLive2ById = async (id) => {
    let nftData = {
        name: 'Sorry no NFT found',
        description:'',
        glbPath:'/test.glb',
        url:'/tim.jpg'
    };
    const nfts = await getMarket2NftsLive();
    console.log('nfts',nfts);
    for (let i = 0; i < nfts.length; i++) {
        console.log('id ',id);
        console.log('id ',nfts[i].token_id);
        if (parseInt(id) === parseInt(nfts[i].token_id)) {
            const url =  nfts[i].url;
            console.log('nfts',url);
            nftData = await getNftMetadata(url);
            break;
        }
    }
    return nftData;
}

const getUserMarketNftsLiveById = async (id) => {
    let nftData = {
        name: 'Sorry no NFT found',
        description:'',
        glbPath:'/test.glb',
        url:'/tim.jpg'
    };
    const nfts = await getUserMarketNftsLive();
    console.log('nfts',nfts);
    for (let i = 0; i < nfts.length; i++) {
        console.log('id ',id);
        console.log('id ',nfts[i].token_id);
        if (parseInt(id) === parseInt(nfts[i].token_id)) {
            const url =  nfts[i].url;
            nftData = await getNftMetadata(url);
            break;
        }
    }
    return nftData;
}

const getMarketNftsLive = async () => {
    let marketNfts = [];
    //const amount = 1;
    const contract = await getLiveMarketNftContract();
    const nftStorage = await contract.storage();
    // console.log(nftStorage);
    //const userWalletAddress = await getPKH();
    const response = await axios.get(
        `https://api.mainnet.tzkt.io/v1/contracts/${config.LIVE_MARKET_CONTRACT_ADDRESS}/bigmaps/ledger/keys`
    );
    const data = response.data;
    let getTokensIds = [];
    for (let i = 0; i < data.length; i++) {
        //console.log(data[i].key.address);
        //if (userWalletAddress === data[i].key.address) {
            getTokensIds.push(data[i].key.nat); 
        //}
    }

    //console.log('getTokensIds',getTokensIds);
    
    // const getTokensIds = await nftStorage.reverse_ledger.get(userWalletAddress);
    if (getTokensIds) {
        marketNfts = await Promise.all(
            getTokensIds.map(async id => {
                const tokenId = 0 + id;
                const metadata = await nftStorage.token_metadata.get(tokenId)
                const tokenInfoBytes = metadata.token_info.get('');
                const tokenInfo = bytes2Char(tokenInfoBytes);
                return {
                    token_id: tokenId,
                    url: tokenInfo.slice(0,7) === "ipfs://" ? tokenInfo.slice(7) : null
                }
            })
        )
        
    }
    return marketNfts;
};

const getMarket2NftsLive = async () => {
    let marketNfts = [];
    //const amount = 1;
    const contract = await getLiveMarket2NftContract();
    const nftStorage = await contract.storage();
    // console.log(nftStorage);
    //const userWalletAddress = await getPKH();
    const response = await axios.get(
        `https://api.mainnet.tzkt.io/v1/contracts/${config.LIVE_MARKET_CONTRACT_ADDRESS2}/bigmaps/ledger/keys`
    );
    const data = response.data;
    let getTokensIds = [];
    for (let i = 0; i < data.length; i++) {
        //console.log(data[i].key.address);
        //if (userWalletAddress === data[i].key.address) {
            getTokensIds.push(data[i].key.nat); 
        //}
    }

    //console.log('getTokensIds',getTokensIds);
    
    // const getTokensIds = await nftStorage.reverse_ledger.get(userWalletAddress);
    if (getTokensIds) {
        marketNfts = await Promise.all(
            getTokensIds.map(async id => {
                const tokenId = 0 + id;
                const metadata = await nftStorage.token_metadata.get(tokenId)
                const tokenInfoBytes = metadata.token_info.get('');
                const tokenInfo = bytes2Char(tokenInfoBytes);
                return {
                    token_id: tokenId,
                    url: tokenInfo.slice(0,7) === "ipfs://" ? tokenInfo.slice(7) : null
                }
            })
        )
        
    }
    return marketNfts;
};

const getUserMarketNfts = async () => {
    const activeAccount = await wallet.client.getActiveAccount();
    if (activeAccount) {
        console.log('already connected');
    } else {
        await disconnectWallet();
        await connectWallet();
    }
    let userNfts = [];
    //const amount = 1;
    const contract = await getMarketNftContract();
    const nftStorage = await contract.storage();
    // console.log(nftStorage);
    const userWalletAddress = await getPKH();
    const response = await axios.get(
        `https://api.hangzhou2net.tzkt.io/v1/contracts/${config.MARKET_CONTRACT_ADDRESS}/bigmaps/ledger/keys`
    );
    const data = response.data;
    let getTokensIds = [];
    for (let i = 0; i < data.length; i++) {
        //console.log(data[i].key.address);
        if (userWalletAddress === data[i].key.address) {
            getTokensIds.push(data[i].key.nat); 
        }
    }

    //console.log('getTokensIds',getTokensIds);
    
    // const getTokensIds = await nftStorage.reverse_ledger.get(userWalletAddress);
    if (getTokensIds) {
        userNfts = await Promise.all(
            getTokensIds.map(async id => {
                const tokenId = 0 + id;
                const metadata = await nftStorage.token_metadata.get(tokenId)
                const tokenInfoBytes = metadata.token_info.get('');
                const tokenInfo = bytes2Char(tokenInfoBytes);
                return {
                    token_id: tokenId,
                    url: tokenInfo.slice(0,7) === "ipfs://" ? tokenInfo.slice(7) : null
                }
            })
        )
        
    }
    return userNfts;
};

const getUserNFTs = async () => {
    const activeAccount = await wallet.client.getActiveAccount();
    if (activeAccount) {
        console.log('already connected');
    } else {
        await disconnectWallet();
        await connectWallet();
    }
    let userNfts = [];
    //const amount = 1;
    const contract = await getContract();
    const nftStorage = await contract.storage();
    //console.log(nftStorage);
    const userWalletAddress = await getPKH();
   
    //const getTokensIds = await nftStorage.ledger.get({0: "tz1e4BYwhFrkFAdCb43YW2KCvAn8xxYJ6zkF",1:19});

   // KT1BaCtLsB5WEXbTDhy74Ba7USJjZsT3KcHM

   // https://api.hangzhou2net.tzkt.io/v1/contracts/KT1BaCtLsB5WEXbTDhy74Ba7USJjZsT3KcHM/bigmaps/ledger/keys

    const response = await axios.get(
        `https://api.hangzhou2net.tzkt.io/v1/contracts/${config.CONTRACT_ADDRESS}/bigmaps/ledger/keys`
    );
    const data = response.data;
    let getTokensIds = [];
    for (let i = 0; i < data.length; i++) {
        //console.log(data[i].key.address);
        if (userWalletAddress === data[i].key.address) {
            getTokensIds.push(data[i].key.nat); 
        }
    }

    console.log('getTokensIds',getTokensIds);
    
    // const getTokensIds = await nftStorage.reverse_ledger.get(userWalletAddress);
    if (getTokensIds) {
        userNfts = await Promise.all(
            getTokensIds.map(async id => {
                const tokenId = 0 + id;
                const metadata = await nftStorage.token_metadata.get(tokenId)
                const tokenInfoBytes = metadata.token_info.get('');
                const tokenInfo = bytes2Char(tokenInfoBytes);
                return {
                    token_id: tokenId,
                    url: tokenInfo.slice(0,7) === "ipfs://" ? tokenInfo.slice(7) : null
                }
            })
        )
        
    }

    return userNfts;


    /*const response = await axios.get(
        `https://api.hangzhou2net.tzkt.io/v1/contracts/${config.CONTRACT_ADDRESS}/bigmaps/token_metadata/keys`
    );
    const data = response.data;
    let tokens = [];
    for (let i = 0; i < data.length; i++) {
        console.log('token ',data[i].value);
        let url = data[i].value.token_info[''];
        console.log('token url ',url);
        if (url) {
            url = bytes2Char(url);
            console.log('decoded token url ',url);
            if (url.indexOf('ipfs://') !== -1) { 
                const token = {
                    token_id: data[i].value.token_id,
                    url,
                };
                tokens.push(token);
            } else {
                console.error('url could not be decoded to ipfs url');
            }
        }
    }
    return tokens;*/
};

const getIfHasNft = async () => {
    const activeAccount = await wallet.client.getActiveAccount();
    if (activeAccount) {
        console.log('already connected');
    } else {
        await disconnectWallet();
        await connectWallet();
    }
    const contract = await getContract();
    const nftStorage = await contract.storage();
    const userWalletAddress = await getPKH();
    const getTokensIds = await nftStorage.ledger.get({0:userWalletAddress});
    if (getTokensIds) {
        return true;
    }
    return false;
};

const getNFTs = async () => {
    const response = await axios.get(
        `https://api.hangzhou2net.tzkt.io/v1/contracts/${config.CONTRACT_ADDRESS}/bigmaps/token_metadata/keys`
    );
    const data = response.data;
    let tokens = [];
    for (let i = 0; i < data.length; i++) {
        //console.log('token ',data[i].value);
        let url = data[i].value.token_info[''];
        //console.log('token url ',url);
        if (url) {
            url = bytes2Char(url);
            //console.log('decoded token url ',url);
            if (url.indexOf('ipfs://') !== -1) { 
                const token = {
                    token_id: data[i].value.token_id,
                    url,
                };
                tokens.push(token);
            } else {
                console.error('url could not be decoded to ipfs url');
            }
        }
    }
    return tokens;
};

export {TezosLive, walletLive, Tezos, wallet, getNftMetadata, getMarketNftsLive2ById, getMarketNftsLiveById, getUserMarketNftsLiveById, getIsWalletActiveLive, getIsWalletActive, connectWalletLiveButton, connectWalletButton, disconnectWalletButton, disconnectWalletLiveButton, getUserMarketNftsLive, getMarketNftsLive, getMarket2NftsLive, getLiveMarketNftContract, connectLiveWallet, disconnectLiveWallet, getPlayerNftContract, getMarketNftContract, getUserMarketNfts, getUserPlayerNfts, checkAccess, connectWallet, disconnectWallet, getPKH, getContract, mintNFT, getNFTs, getUserNFTs, getIfHasNft};
